export default __webpack_public_path__ + "static/argos-359cb79cead921a327f13f16ea376c0d.png";